<div class="utf-auth-single-id-container" *ngIf="showHomepage">
  <div>
    <div class="header">{{cfetLabels.utf_auth_single_id_homepage.heading}}</div>
    <p *ngIf="EmailFormatUser" class="description">{{cfetLabels.utf_auth_single_id_homepage.desc}}</p>
    <p *ngIf="!EmailFormatUser" class="description">{{cfetLabels.utf_new_single_id_page.desc}}</p>
    <div id="content-div">
      <p *ngIf="!EmailFormatUser" id="content">{{cfetLabels.utf_new_single_id_page.content}}</p>
    </div>
    <img id="merge-icon" src="assets/images/merge_logos.png" alt="merge-icon">
  </div>
  <p *ngIf="EmailFormatUser" class="att-email">{{attEmail}}</p>
  <div *ngIf="!EmailFormatUser" class="form-group">
    <form [formGroup]="emailAddressForm">
      <div class="row no-gutters form-row" [class.error]="(emailAddressError || showDupeErrorMsg)">
        <div class="col-md-12">
          <label for="emailAddress" id="email_address">{{cfetLabels.cfet_customer_profile.email_add}}</label>
          <div class="email-address-inputbox">
            <input class="form-control" id="emailId" [(ngModel)] = "userId" formControlName="emailAddress" tabindex="0" type="text"
              (blur)="validateEmailAddress()" autocomplete="off" maxlength="256">
            <div *ngIf="emailAddressError || showDupeErrorMsg" role="alert" [attr.aria-atomic]="true"
              [ngClass]="{'error-msg' : (emailAddressError || showDupeErrorMsg)}">
              <em class="icon-badgealert" aria-hidden="true"></em>
              <span *ngIf="emailAddressError">{{cfetMessages.valid_emailAddress}}</span>
              <span *ngIf="showDupeErrorMsg">{{cfetMessages.emailAlreadyExists}}</span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <hr>
  <div class="col-12" class="btn-container">
    <a tabindex="0" type="button" id="cancel_link" class="utf-cancel-link" (click)="cancelModal($event)"
      (keyup)="cancelModal($event)">
      <em aria-label=""></em>
      {{cfetButtonLabels.button_labels.cancel}}</a>

    <button *ngIf="EmailFormatUser" type="button" id="btn-submit" (click)="use1Id($event)" class="utf-button-blue" (keyup)="use1Id($event)"
      tabindex="0">
      {{cfetButtonLabels.button_labels.utf_single_id}}</button>
      <button *ngIf="!EmailFormatUser" type="button" id="btn-submit" (click)="useSeparateId($event)" class="utf-button-blue" (keyup)="useSeparateId($event)" [disabled]="disabledUseOneIdButton"
      tabindex="0">
      {{cfetButtonLabels.button_labels.utf_single_id}}</button>
  </div>
  <div class="footer-text">
    <p>{{cfetLabels.utf_auth_single_id_homepage.footer_content}}</p>
  </div>
</div>
<div [ngClass]="showCancelModal ? 'open-eligibility-step-cancel-modal' : 'hide-cancel-modal'">
  <app-cancel-eligibility-step-modal [openModal]="openCancelModal" (closeModal)="closeModal($event)">
  </app-cancel-eligibility-step-modal>
</div>
<app-utf-auth-separate-id-form *ngIf="showIdForm" (showHomepage)="hideHomePage()"></app-utf-auth-separate-id-form>
